import React from "react";
import FollowDesignerButton from "web/react/components/follow-designer-button/follow-designer-button";
import { HStack } from "web/react/emo/h-stack";
import { Text } from "web/react/emo/text";
import { gettext } from "web/script/modules/django-i18n";
import { FollowButtonSerializer } from "web/types/serializers";

export interface FeedFollowCtaWithDetailsProps {
    followButton: FollowButtonSerializer | null;
    followersCountLabel: string | null;
    designerName: string;
}

export function FeedFollowCtaWithDetails({
    followButton,
    followersCountLabel,
    designerName,
}: FeedFollowCtaWithDetailsProps): React.ReactElement {
    return (
        <HStack spacing="xs" align="center">
            {followButton && (
                <FollowDesignerButton
                    notFollowedText={gettext("feed.store_updates.cta")}
                    followedText={gettext("feed.following_store_or_brand.label")}
                    analyticsParameters={["du_feed_cta", "click_top_cta", "du_cta"]}
                    lystId={followButton.lyst_id}
                    isAuthenticated={followButton.is_authenticated}
                    isFollowing={followButton.is_following as string}
                    designerName={designerName}
                />
            )}
            {!!followersCountLabel && (
                <Text dataTestId="followers_label" as="span" textStyle="body-s" color="secondary">
                    {followersCountLabel}
                </Text>
            )}
        </HStack>
    );
}
